import React from 'react';
import { ColumnType } from 'antd/es/table';
import { priceFormatter } from 'common/helpers/format.helper';
import { Clockwise, Coins, HourglassSimpleLow, Lightbulb, MagicWand, MegaphoneSimple, Warning } from 'common/svg';

export interface ITrackStoreStoreCollection extends Components.Schemas.TrackStoreStoreCollectionDto {}
export interface ITrackStoreStore extends Components.Schemas.TrackStoreStoreDto {}

export interface ITrackStoreSummaryFilters extends Paths.TrackStoreControllerGetSummary.QueryParameters {}
export interface ITrackStoreSummary extends Components.Schemas.TrackStoreSummaryDto {}
export interface ITrackStoreMetric extends Components.Schemas.TrackStoreMetricDto {}

export interface ITrackStoreWeeklyGridFilters extends Paths.TrackStoreControllerGetWeeklyGrid.QueryParameters {}
export interface ITrackStoreWeeklyGrid extends Components.Schemas.TrackStoreWeeklyGridDto {}
export interface ITrackStoreDailyMetric extends Components.Schemas.TrackStoreDailyMetricDto {}

export interface ITrackStoreNotificationCollectionFilters
  extends Paths.TrackStoreControllerGetNotifications.QueryParameters {}
export interface ITrackStoreNotificationCollection extends Components.Schemas.TrackStoreNotificationCollectionDto {}
export interface ITrackStoreNotification extends Components.Schemas.TrackStoreNotificationDto {}

export interface ITrackStoreAllStoresCollection extends Components.Schemas.TrackStoreAllStoresCollectionDto {}
export interface ITrackStoreAllStoresItem extends Components.Schemas.TrackStoreAllStoresItemDto {}

export interface ITrackStoreOnDutyCollectionFilters extends Paths.TrackStoreControllerGetOnDuty.QueryParameters {}
export interface ITrackStoreOnDutyCollection extends Components.Schemas.TrackStoreOnDutyCollectionDto {}
export interface ITrackStoreOnDuty extends Components.Schemas.TrackStoreOnDutyDto {}

export interface ITrackStoreStoreCard extends ITrackStoreAllStoresItem {}

export interface ITrackStoreLiveStoresCollection extends Components.Schemas.TrackStoreLiveStoresCollectionDto {}
export interface ITrackStoreLiveStore extends Components.Schemas.TrackStoreLiveStoreDto {}

export interface ITrackStoreOrderCollectionFilters extends Paths.TrackStoreControllerGetOrders.QueryParameters {}
export interface ITrackStoreOrderCollection extends Components.Schemas.TrackStoreOrderCollectionDto {}
export interface ITrackStoreOrderListItem extends Components.Schemas.TrackStoreOrderListItemDto {}

export interface ITrackStoreOrderDetailsFilters
  extends Paths.TrackStoreControllerGetOrderDetails.PathParameters,
    Paths.TrackStoreControllerGetOrderDetails.QueryParameters {}
export interface ITrackStoreOrderDetails extends Components.Schemas.TrackStoreOrderDetailsDto {}
export interface ITrackStoreOrderDetailItem extends Components.Schemas.TrackStoreOrderDetailItemDto {
  key: React.Key;
}

export enum ETrackStoreNotificationType {
  PoNotYetPlaced = 'po-not-yet-placed',
  PoPaymentNotDeposited = 'po-payment-not-deposited',
  StoreNotSynced = 'store-not-synced',
  OosCritical = 'oos-critical',
  BsotExpired = 'bsot-expired',
  BsotToExpire = 'bsot-to-expire',
  Announcement = 'announcement',
  FoodForThought = 'food-for-thought',
}

export enum ETrackStoreNotificationLabel {
  'po-not-yet-placed' = 'PO not yet placed',
  'po-payment-not-deposited' = 'PO payment not yet deposited',
  'store-not-synced' = 'Store not synced for 1 hr',
  'oos-critical' = 'OOS / Critical',
  'bsot-expired' = 'BSOT EXPIRED',
  'bsot-to-expire' = 'BSOT to expire in 30 days',
  'announcement' = 'Announcement',
  'food-for-thought' = 'Food for Thought',
}

export enum ETrackStoreOrderType {
  Reg = 'reg',
  Adv = 'adv',
}

export enum ETrackStoreOrderView {
  Queue = 'queue',
  Served = 'served',
}

export const trackStoreOrderItemsConfig: ColumnType<ITrackStoreOrderDetailItem>[] = [
  {
    key: 'product',
    dataIndex: 'product',
    title: 'Item',
  },
  {
    key: 'quantity',
    dataIndex: 'quantity',
    title: 'Qty',
    onHeaderCell: () => {
      return {
        style: { textAlign: 'end' },
      };
    },
    onCell: () => {
      return {
        style: { textAlign: 'end' },
      };
    },
  },
  {
    key: 'unitPrice',
    dataIndex: 'unitPrice',
    title: 'Unit Cost',
    onHeaderCell: () => {
      return {
        style: { textAlign: 'end' },
      };
    },
    onCell: () => {
      return {
        style: { textAlign: 'end' },
      };
    },
    render: (_, record) => priceFormatter(record.unitPrice),
  },
  {
    key: 'totalPrice',
    dataIndex: 'totalPrice',
    title: 'Price',
    onHeaderCell: () => {
      return {
        style: { textAlign: 'end' },
      };
    },
    onCell: () => {
      return {
        style: { textAlign: 'end' },
      };
    },
    render: (_, record) => priceFormatter(record.totalPrice),
  },
];

export const trackStoreNotificationIcons = {
  'po-not-yet-placed': <MagicWand className="icon-blue" />,
  'po-payment-not-deposited': <Coins className="icon-blue" />,
  'store-not-synced': <Clockwise className="icon-blue" />,
  'oos-critical': <Warning />,
  'bsot-expired': <HourglassSimpleLow />,
  'bsot-to-expire': <HourglassSimpleLow />,
  announcement: <MegaphoneSimple />,
  'food-for-thought': <Lightbulb />,
};
